import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[nairaSeparator]',
  standalone: false
})
export class NairaSeparatorDirective {

  constructor(private _inputEl: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    if (this._inputEl.nativeElement.value === '-') return;

    let value = this._inputEl.nativeElement.value.replace(/,/g, '').replace(/₦/g, '').trim();

    let toInt: number;
    let toLocale: string;

    if (value.split('.').length > 1) {
      let decimalPart = isNaN(parseInt(value.split('.')[1])) ? '' : parseInt(value.split('.')[1]);
      toInt = parseInt(value);
      toLocale = `₦${toInt.toLocaleString('en-US')}.${decimalPart}`;
    } else {
      toInt = parseInt(value);
      toLocale = `₦${toInt.toLocaleString('en-US')}`;
    }

    this._inputEl.nativeElement.value = isNaN(toInt) ? '' : toLocale;
  }
}
